export * from './NewsSlider';
